export default __webpack_public_path__ + "static/media/google-play-store-qr.3a346bf5.svg";